import { Tooltip, TooltipTrigger, TooltipContent } from './ui/tooltip';

export const IconTip = ({ label, children, side = 'top' }) => (
  <Tooltip>
    <TooltipTrigger asChild>{children}</TooltipTrigger>
    <TooltipContent side={side}>{label}</TooltipContent>
  </Tooltip>
);
